"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RHFStandardTextField = exports.RHFPasswordField = exports.RHFMailField = exports.RHFInputLabel = exports.StyledRHFInputLabel = exports.RHFDateField = exports.RHFDateTimeField = exports.RHFTelField = exports.RHFResizeTextArea = exports.RHFTextArea = exports.RHFNumberField = exports.RHFTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
// eslint-disable-next-line import/no-duplicates -- 暫定対応
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
var OutlinedInput_1 = __importDefault(require("@mui/material/OutlinedInput"));
var InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var styles_1 = require("@mui/material/styles");
var date_fns_1 = require("date-fns");
var CustomProvider_1 = __importDefault(require("rsuite/CustomProvider"));
var DatePicker_1 = __importDefault(require("rsuite/DatePicker"));
var MailOutline_1 = __importDefault(require("@mui/icons-material/MailOutline"));
var Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
var VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
// eslint-disable-next-line import/no-duplicates -- 暫定対応
var TextField_2 = __importDefault(require("@mui/material/TextField"));
var RHFInput_1 = require("@domain/RHFInput");
var theme_1 = require("@components/providers/EntryCommon/theme");
/**
 * ReactHookForm用のtext型のinput
 * @deprecated resources/js/react/components/commonsのComponentを利用してください。
 */
var RHFTextField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control;
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-text-field", children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(StyledTextField, __assign({}, field, { placeholder: placeholder, type: "text", error: fieldState.invalid, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }))] }));
        } }));
};
exports.RHFTextField = RHFTextField;
/**
 * ReactHookForm用のnumber型のinput
 */
var RHFNumberField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control;
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-number-field", children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(StyledTextField, __assign({}, field, { placeholder: placeholder, type: "number", error: fieldState.invalid, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }))] }));
        } }));
};
exports.RHFNumberField = RHFNumberField;
/**
 * ReactHookForm用の複数行text型のinput
 */
var RHFTextArea = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, rows = _a.rows, control = _a.control;
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-textarea-field", children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(StyledMTextArea, __assign({}, field, { placeholder: placeholder, type: "text", error: fieldState.invalid, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, multiline: true, rows: rows }))] }));
        } }));
};
exports.RHFTextArea = RHFTextArea;
/**
 * ReactHookForm用のリサイズ可能なテキストエリア
 */
var RHFResizeTextArea = function (_a) {
    var _b;
    var name = _a.name, maxLength = _a.maxLength, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, rows = _a.rows, control = _a.control, minWidth = _a.minWidth, width = _a.width, maxHeight = _a.maxHeight, defaultValue = _a.defaultValue;
    var field = (0, react_hook_form_1.useController)({
        name: name,
        control: control,
        rules: validationRules,
    }).field;
    var counter = ((_b = field.value) === null || _b === void 0 ? void 0 : _b.length) || 0;
    var isErrorLength = counter > (maxLength || 0);
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: {
                    margin: "0 auto",
                    width: "fit-content",
                    maxWidth: "100%",
                    minWidth: minWidth,
                    "& label": {
                        margin: 0,
                    },
                }, children: [label && ((0, jsx_runtime_1.jsxs)(Box_1.default, { display: "flex", children: [(0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)("span", { style: { color: "#EA2C24", marginLeft: "4px" }, children: "*" })] })), (0, jsx_runtime_1.jsx)(StyledResizeTextArea, __assign({}, field, { placeholder: placeholder, type: "text", error: fieldState.invalid, multiline: true, rows: rows, minWidth: minWidth, width: width, maxHeight: maxHeight, defaultValue: defaultValue, helperText: (0, jsx_runtime_1.jsxs)(Box_1.default, { component: "span", display: "flex", justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", fontWeight: 500, lineHeight: "14px", color: fieldState.invalid || isErrorLength
                                        ? "error"
                                        : theme_1.chatBoostTheme.palette.neutral.main, children: fieldState.error ? fieldState.error.message : "" }), (0, jsx_runtime_1.jsxs)(Typography_1.default, { variant: "caption", fontWeight: 500, lineHeight: "14px", sx: { marginLeft: "16px" }, color: theme_1.chatBoostTheme.palette.neutral.main, children: [counter, "/", maxLength] })] }) }))] }));
        } }));
};
exports.RHFResizeTextArea = RHFResizeTextArea;
/**
 * ReactHookForm用の複数行tel型のinput
 */
var RHFTelField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control;
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-tel-field", children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(StyledTextField, __assign({}, field, { placeholder: placeholder, type: "tel", error: fieldState.invalid, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }))] }));
        } }));
};
exports.RHFTelField = RHFTelField;
/**
 * ReactHookForm用のdatetime型のinput
 */
var RHFDateTimeField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control, _b = _a.disablePast, disablePast = _b === void 0 ? true : _b;
    var _c = (0, react_1.useState)(null), selectedHours = _c[0], setSelectedHours = _c[1];
    var locale = {
        Calendar: RHFInput_1.Calendar,
        DatePicker: __assign({}, RHFInput_1.Calendar),
    };
    var Ranges = [
        {
            label: "今日",
            value: (0, date_fns_1.addMinutes)(new Date(), 1),
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("style", { children: DatePickerRSStyle }), (0, jsx_runtime_1.jsx)(StyledRSDateTimeField, { children: (0, jsx_runtime_1.jsx)(CustomProvider_1.default, { locale: locale, children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, rules: validationRules, render: function (_a) {
                            var _b;
                            var _c = _a.field, onChange = _c.onChange, value = _c.value, fieldState = _a.fieldState;
                            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-date-time-field", sx: {
                                    "& .rs-btn.rs-btn-default.rs-picker-toggle": {
                                        borderColor: fieldState.invalid
                                            ? "#EA2C24!important"
                                            : "#8DA3BE!important",
                                        boxShadow: "none",
                                    },
                                }, children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(DatePicker_1.default, { limitEndYear: 5, placeholder: placeholder, format: "yyyy/MM/dd HH:mm", 
                                        // TODO: valueとonChangeの型が合っていない。。。
                                        value: value ? new Date(value) : null, defaultOpen: false, ranges: Ranges, onChange: onChange, onSelect: function (date) {
                                            setSelectedHours(date ? date.getHours() : null);
                                        }, placement: "auto", disabledDate: function (date) {
                                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- 暫定対応
                                            return disablePast ? (0, date_fns_1.isBefore)(date, (0, RHFInput_1.getToday)()) : false;
                                        }, disabledHours: function (hour, date) {
                                            return disablePast ? (0, RHFInput_1.isDisabledHour)(hour, date) : false;
                                        }, disabledMinutes: function (minute, date) {
                                            return disablePast
                                                ? (0, RHFInput_1.isDisabledMinute)(minute, date, selectedHours)
                                                : false;
                                        }, style: {
                                            width: "100%",
                                        } }), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", color: "error", className: "custom-datetime-error", children: ((_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message) || "" })] }));
                        } }) }) })] }));
};
exports.RHFDateTimeField = RHFDateTimeField;
/**
 * ReactHookForm用のdate型のinput
 */
var RHFDateField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control;
    var locale = {
        Calendar: RHFInput_1.Calendar,
        DatePicker: __assign({}, RHFInput_1.Calendar),
    };
    var Ranges = [
        {
            label: "今日",
            value: new Date(),
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("style", { children: DatePickerRSStyle }), (0, jsx_runtime_1.jsx)(StyledRSDateTimeField, { children: (0, jsx_runtime_1.jsx)(CustomProvider_1.default, { locale: locale, children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, rules: validationRules, render: function (_a) {
                            var _b;
                            var _c = _a.field, onChange = _c.onChange, value = _c.value, fieldState = _a.fieldState;
                            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-date-field", sx: {
                                    "& .rs-btn.rs-btn-default.rs-picker-toggle": {
                                        borderColor: fieldState.invalid
                                            ? "#EA2C24!important"
                                            : "#8DA3BE!important",
                                        boxShadow: "none",
                                    },
                                }, children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(DatePicker_1.default, { limitEndYear: 5, placeholder: placeholder, format: "yyyy/MM/dd", value: value ? new Date(value) : null, defaultOpen: false, ranges: Ranges, onChange: onChange, placement: "auto", style: {
                                            width: "100%",
                                        } }), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", color: "error", children: ((_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message) || "" })] }));
                        } }) }) })] }));
};
exports.RHFDateField = RHFDateField;
var StyledTextField = (0, styles_1.styled)(TextField_1.default)(function () { return ({
    width: "100%",
    mt: 0,
    "& input": {
        padding: "12px 8px",
        lineHeight: "1.8",
    },
    "& .MuiInputBase-root": {
        height: "48px",
        "&::before": {
            borderColor: "#8da3be",
        },
        "&:hover": {
            "&:not(.Mui-disabled)": {
                "&::before": {
                    borderColor: "#8da3be",
                },
            },
        },
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#8da3be",
    },
    "& .MuiFormHelperText-root": {
        marginLeft: "0px",
    },
}); });
var StyledMTextArea = (0, styles_1.styled)(TextField_1.default)(function () { return ({
    width: "100%",
    mt: 0,
    "& textarea": {
        padding: "12px 8px",
        lineHeight: "1.8",
    },
    "& .MuiInputBase-root": {
        padding: "0px",
        "&::before": {
            borderColor: "#8da3be",
        },
        "&:hover": {
            "&:not(.Mui-disabled)": {
                "&::before": {
                    borderColor: "#8da3be",
                },
            },
        },
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#8da3be",
    },
    "& .MuiFormHelperText-root": {
        marginLeft: "0px",
    },
}); });
var StyledRSDateTimeField = (0, styles_1.styled)(Box_1.default)(function () { return ({
    "& svg": {
        top: "12px!important",
        fontSize: "18px",
    },
    "& .rs-picker-toggle": {
        height: "48px",
        display: "flex!important",
        alignItems: "center",
        fontSize: "16px",
    },
    "& .rs-picker .rs-btn-close": {
        top: "14px!important",
        right: "40px!important",
        "&:hover": {
            color: "#3B91D1",
        },
    },
    "& .rs-picker-default .rs-picker-toggle": {
        border: "1px solid #8DA3BE!important",
        borderRadius: "4px",
    },
    "& .rs-picker-toggle-placeholder": {
        color: "#8DA3BE!important",
    },
    "& .rs-picker-toggle-value": {
        color: "#39546C!important",
    },
    "& input.rs-picker-toggle-textbox::placeholder": {
        color: "#8DA3BE!important",
    },
}); });
var DatePickerRSStyle = "\n.rs-picker-date-menu {z-index: 9999!important;}\n.rs-btn {\n  border-radius: 4px;\n}\n.rs-btn-primary {\n    background: transparent!important;\n    color: #3B91D1!important;\n    border: solid 1px #3B91D1!important;\n}\n.react-content-wrapper {min-height: auto!important;}\n.rs-picker-toolbar {\n    font-family: 'Noto Sans JP','Hiragino Sans',sans-serif;\n}\n.rs-calendar-table-cell-content {\n  border-radius: 4px;\n}\n.rs-calendar-table-cell-selected .rs-calendar-table-cell-content {\n    background: #3B91D1!important;\n}\n.rs-calendar-table-cell-selected:hover .rs-calendar-table-cell-content {\n    color: #FFFFFF !important;\n}\n.rs-btn-sm {\n    color: #3B91D1!important;\n    font-weight: 500!important;\n}\n.rs-calendar-time-dropdown-cell.rs-calendar-time-dropdown-cell-active {\n    background: #3B91D1!important;\n}\n.rs-calendar-show-time-dropdown .rs-calendar-header-title-time, .rs-calendar-header-time-toolbar .rs-calendar-header-title {\n    color: #3B91D1!important;\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #3B91D1!important;\n}\n.rs-calendar-month-dropdown-year-active {\n    color: #3B91D1!important;\n}\n.rs-calendar-month-dropdown-cell-active .rs-calendar-month-dropdown-cell-content {\n    background:#3B91D1!important;\n}\n.rs-calendar-show-month-dropdown .rs-calendar-header-title-date {\n    color: #3B91D1!important;\n}\n.rs-calendar-table-header-row .rs-calendar-table-cell:hover .rs-calendar-table-cell-content {\n    background: transparent!important;\n    color: #8e8e93!important;\n}\n";
var StyledResizeTextArea = (0, styles_1.styled)(TextField_1.default, {
    shouldForwardProp: function (prop) {
        return prop !== "minWidth" && prop !== "width" && prop !== "maxHeight";
    },
})(function (_a) {
    var _b = _a.minWidth, minWidth = _b === void 0 ? 216 : _b, _c = _a.width, width = _c === void 0 ? 400 : _c, _d = _a.maxHeight, maxHeight = _d === void 0 ? 347 : _d;
    return {
        width: "100%",
        "& textarea": {
            padding: "9px 12px 10px 12px",
            lineHeight: "1.8",
            fontSize: "16px",
            fontWeight: 500,
            maxWidth: "100%",
            minWidth: minWidth,
            width: width,
            maxHeight: maxHeight,
            resize: "both",
        },
        "& .MuiInputBase-root": {
            display: "flex",
            alignItems: "flex-start",
            padding: "0px",
            maxWidth: "100%",
            width: "fit-content",
            "&::before": {
                borderColor: "#8da3be",
            },
            "&:hover": {
                "&:not(.Mui-disabled)": {
                    "&::before": {
                        borderColor: "#8da3be",
                    },
                },
            },
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#8da3be",
        },
        "& .MuiFormHelperText-root": {
            marginLeft: "0px",
            marginRight: "0px",
        },
    };
});
exports.StyledRHFInputLabel = (0, styles_1.styled)(InputLabel_1.default)({
    fontWeight: 500,
    color: "#8DA3BE",
    fontSize: "10px",
    paddingBottom: "6px",
    whiteSpace: "initial",
    overflow: "initial",
    textOverflow: "initial",
});
/**
 * ReactHookForm用のフォームラベル
 */
var RHFInputLabel = function (_a) {
    var label = _a.label;
    return (0, jsx_runtime_1.jsx)(exports.StyledRHFInputLabel, { children: label });
};
exports.RHFInputLabel = RHFInputLabel;
var StyledField = (0, styles_1.styled)(OutlinedInput_1.default)(function () { return ({
    width: "100%",
    marginTop: 0,
    background: "#FFFFFF",
    "& input": {
        padding: "12.5px 12px",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "28px",
        color: "#39546C!important",
    },
    "& input:-internal-autofill-selected": {
        boxShadow: "0px 0px 100px 100px #fff inset",
        color: "#39546C!important",
        WebkitTextFillColor: "#39546C !important",
    },
    "& .MuiInputBase-root": {
        height: "48px",
        "&::before": {
            borderColor: "#8da3be",
        },
        "&:hover": {
            "&:not(.Mui-disabled)": {
                "&::before": {
                    borderColor: "#8da3be",
                },
            },
        },
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#8da3be",
        "& legend": { display: "none" },
    },
    "& fieldset": {
        inset: 0,
    },
    "& legend": { display: "none" },
    "&:hover:not(.Mui-disabled):not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #39546C",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #24A6F7",
    },
    "&.Mui-error:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
        border: "2px solid #EA2C24",
    },
}); });
var sizeStyles = {
    large: { padding: "12px", fontSize: "18px", lineHeight: "180%" },
    medium: { padding: "9px 8px 10px 8px", fontSize: "16px", lineHeight: "180%" },
    small: { padding: "5px 8px 6px 8px", fontSize: "16px", lineHeight: "180%" },
    xSmall: { padding: "5px 4px 5px 4px", fontSize: "12px", lineHeight: "140%" },
};
var getPaddingForVariant = function (variant, formSize, defaultPadding) {
    if (variant !== "outlined")
        return defaultPadding;
    switch (formSize) {
        case "medium":
            return "9px 12px 10px 12px";
        case "xSmall":
            return "5px 8px 5px 8px";
        default:
            return defaultPadding;
    }
};
var StyledMTextField = (0, styles_1.styled)(TextField_2.default, {
    // shouldForwardPropは "formSize" をDOM要素への属性として渡さないようにするために使用
    // Doc: https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function (prop) { return prop !== "formSize"; },
})(function (_a) {
    var theme = _a.theme, _b = _a.formSize, formSize = _b === void 0 ? "medium" : _b, disabled = _a.disabled, _c = _a.variant, variant = _c === void 0 ? "standard" : _c;
    var _d = sizeStyles[formSize] || sizeStyles.medium, padding = _d.padding, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    // variantがoutlinedの場合のpaddingを取得
    var finalPadding = getPaddingForVariant(variant, formSize, padding);
    return {
        "& input": {
            color: disabled
                ? theme.palette.text.disabled
                : theme.palette.secondary.main,
            padding: finalPadding,
            lineHeight: lineHeight,
            height: "auto",
            fontSize: fontSize,
            fontWeight: 500,
            "&::placeholder": {
                color: theme.palette.neutral.main,
                opacity: 1,
            },
        },
        // valiant: standard
        "& .MuiInputBase-root": {
            "&::before": {
                borderTop: "0",
                borderRight: "0",
                borderLeft: "0",
                borderBottom: disabled
                    ? "1px dotted " + theme.palette.neutral.main
                    : "1px solid ".concat(theme.palette.neutral.main),
            },
            "&:hover:not(.Mui-disabled):not(.Mui-focused)::before": {
                borderTop: "0",
                borderRight: "0",
                borderLeft: "0",
                borderBottom: formSize === "xSmall"
                    ? "1px solid ".concat(theme.palette.secondary.main)
                    : "2px solid ".concat(theme.palette.secondary.main),
            },
            "&.Mui-focused::before": {
                borderBottom: formSize === "xSmall"
                    ? "1px solid ".concat(theme.palette.primary.light)
                    : "2px solid ".concat(theme.palette.primary.light),
            },
            "&.Mui-error:not(.Mui-disabled)::before": {
                borderBottom: formSize === "xSmall"
                    ? "1px solid ".concat(theme.palette.error.main)
                    : "2px solid ".concat(theme.palette.error.main),
            },
        },
        // valiant: outlined
        "& .MuiOutlinedInput-root": {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.neutral.main,
                borderStyle: disabled ? "dotted" : "solid",
            },
            "&:hover:not(.Mui-disabled):not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
                border: formSize === "xSmall"
                    ? "1px solid ".concat(theme.palette.secondary.main)
                    : "2px solid ".concat(theme.palette.secondary.main),
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: formSize === "xSmall"
                    ? "1px solid ".concat(theme.palette.primary.light)
                    : "2px solid ".concat(theme.palette.primary.light),
            },
            "&.Mui-error:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
                border: formSize === "xSmall"
                    ? "1px solid ".concat(theme.palette.error.main)
                    : "2px solid ".concat(theme.palette.error.main),
            },
            "& legend": { display: "none" },
            "& fieldset": {
                inset: 0,
            },
        },
        "& .MuiFormHelperText-root": {
            marginLeft: "0",
            marginRight: "0",
            color: disabled
                ? theme.palette.text.disabled
                : theme.palette.text.secondary,
            marginTop: formSize === "xSmall" ? "6px" : "8px",
        },
    };
});
var StyledMTextLabel = (0, styles_1.styled)(Typography_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.neutral.main,
        fontSize: "10px",
        fontWeight: 500,
        lineHeight: "10px",
        whiteSpace: "initial",
        overflow: "initial",
        textOverflow: "initial",
    });
});
/**
 * ReactHookForm用のmail型アイコン付きのinput
 */
var RHFMailField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control, _b = _a.isError, isError = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-mail-field", children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(StyledField, __assign({}, field, { placeholder: placeholder, type: "mail", error: fieldState.invalid || isError, endAdornment: (0, jsx_runtime_1.jsx)(InputAdornment_1.default, { position: "end", children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { sx: {
                                    "&:hover": {
                                        backgroundColor: "transparent",
                                        cursor: "default",
                                    },
                                }, "aria-label": "toggle password visibility", 
                                //   onClick={handleClickShowPassword}
                                //   onMouseDown={handleMouseDownPassword}
                                edge: "end", children: (0, jsx_runtime_1.jsx)(MailOutline_1.default, { sx: { color: "#39546C", width: "20px", height: "20px" } }) }) }), label: null })), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", color: "error", sx: { fontSize: "10px" }, children: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })] }));
        } }));
};
exports.RHFMailField = RHFMailField;
/**
 * ReactHookForm用のpassword型アイコン付きのinput
 */
var RHFPasswordField = function (_a) {
    var name = _a.name, label = _a.label, placeholder = _a.placeholder, validationRules = _a.validationRules, control = _a.control, _b = _a.isError, isError = _b === void 0 ? false : _b;
    var _c = (0, react_1.useState)(false), showPassword = _c[0], setShowPassword = _c[1];
    var handleClickShowPassword = function () { return setShowPassword(function (show) { return !show; }); };
    var handleMouseDownPassword = function (event) {
        event.preventDefault();
    };
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: control, rules: validationRules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return ((0, jsx_runtime_1.jsxs)(Box_1.default, { "data-testid": "react-hook-form-password-field", children: [label && (0, jsx_runtime_1.jsx)(exports.RHFInputLabel, { label: label }), (0, jsx_runtime_1.jsx)(StyledField, __assign({}, field, { placeholder: placeholder, type: showPassword ? "text" : "password", error: fieldState.invalid || isError, endAdornment: (0, jsx_runtime_1.jsx)(InputAdornment_1.default, { position: "end", children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, edge: "end", children: showPassword ? ((0, jsx_runtime_1.jsx)(Visibility_1.default, { sx: { color: "#39546C", width: "20px", height: "20px" } })) : ((0, jsx_runtime_1.jsx)(VisibilityOff_1.default, { sx: { color: "#39546C", width: "20px", height: "20px" } })) }) }), label: null })), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", color: "error", sx: { fontSize: "10px" }, children: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })] }));
        } }));
};
exports.RHFPasswordField = RHFPasswordField;
var RHFStandardTextField = function (_a) {
    var _b;
    var maxLength = _a.maxLength, validationRules = _a.validationRules, control = _a.control, name = _a.name, _c = _a.disabled, disabled = _c === void 0 ? false : _c, label = _a.label, errorMessagePosition = _a.errorMessagePosition, _d = _a.formSize, formSize = _d === void 0 ? "medium" : _d, _e = _a.variant, variant = _e === void 0 ? "standard" : _e, _f = _a.showRequiredMark, showRequiredMark = _f === void 0 ? false : _f, rest = __rest(_a, ["maxLength", "validationRules", "control", "name", "disabled", "label", "errorMessagePosition", "formSize", "variant", "showRequiredMark"]);
    var _g = (0, react_hook_form_1.useController)({
        name: name,
        control: control,
        rules: validationRules,
    }), field = _g.field, fieldState = _g.fieldState;
    var counter = ((_b = field.value) === null || _b === void 0 ? void 0 : _b.length) || 0;
    // maxLengthで設定した値以上に入力された時にエラー表示になるように使用
    // RHFのバリデーションを有効にするために、validationRules内にmaxLengthの設定が別途必要
    var isErrorLength = maxLength ? counter > maxLength : false;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { display: "flex", flexDirection: "column", children: [label && ((0, jsx_runtime_1.jsxs)(StyledMTextLabel, { variant: "caption", style: {
                    color: fieldState.invalid &&
                        errorMessagePosition === "top" &&
                        fieldState.error
                        ? theme_1.chatBoostTheme.palette.error.main
                        : theme_1.chatBoostTheme.palette.neutral.main,
                    marginBottom: formSize == "large" ? "8px" : "6px",
                }, children: [fieldState.invalid &&
                        errorMessagePosition === "top" &&
                        fieldState.error
                        ? fieldState.error.message
                        : label, showRequiredMark && ((0, jsx_runtime_1.jsx)("span", { style: { color: "#EA2C24", marginLeft: "4px" }, children: "*" }))] })), (0, jsx_runtime_1.jsx)(StyledMTextField, __assign({ variant: variant, formSize: formSize, error: fieldState.invalid || isErrorLength, value: field.value || "", disabled: disabled, onChange: function (e) {
                    field.onChange(e);
                } }, rest, { helperText: (0, jsx_runtime_1.jsxs)(Box_1.default, { component: "span", display: "flex", justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", fontWeight: 500, lineHeight: "14px", color: disabled
                                ? theme_1.chatBoostTheme.palette.text.disabled
                                : errorMessagePosition === "bottom" &&
                                    (fieldState.invalid || isErrorLength)
                                    ? "error"
                                    : theme_1.chatBoostTheme.palette.neutral.main, children: errorMessagePosition === "bottom" && fieldState.error
                                ? fieldState.error.message
                                : rest.helperText || "" }), maxLength ? ((0, jsx_runtime_1.jsxs)(Typography_1.default, { variant: "caption", fontWeight: 500, lineHeight: "14px", sx: { marginLeft: "16px" }, color: disabled
                                ? theme_1.chatBoostTheme.palette.text.disabled
                                : isErrorLength
                                    ? "error"
                                    : theme_1.chatBoostTheme.palette.neutral.main, children: [counter, "/", maxLength] })) : null] }) }))] }));
};
exports.RHFStandardTextField = RHFStandardTextField;
